export const NUMBER_TOTAL_TREND_ARTICLES = 5
export const NUMBER_TREND_ARTICLES = 3
export const NUMBER_RECENT_ARTICLES = 8
export const NUMBER_CLASSIC_ARTICLES = 4
export const SEARCH_BAR_MAXIMUM_ARTICLES = 20
